import { render } from "./ProductCostList.vue?vue&type=template&id=730c2334&scoped=true"
import script from "./ProductCostList.vue?vue&type=script&lang=js"
export * from "./ProductCostList.vue?vue&type=script&lang=js"

import "./ProductCostList.vue?vue&type=style&index=0&id=730c2334&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-730c2334"]])

export default __exports__